import {createSelector} from '@ngrx/store';


import {AppState} from '../../../reducers';
import * as fromFormResponseReducer from './form-response.reducer';
import {DatePipe} from "@angular/common";

export const currentState = (state: AppState) => (state[fromFormResponseReducer.formResponsesFeatureKey]);

export const selectAllFromResponse = createSelector(currentState, fromFormResponseReducer.selectAll);

export const selectTotalFromResponse = createSelector(currentState, fromFormResponseReducer.selectTotal);

export const selectModifiedFromResponses = createSelector(selectAllFromResponse, (serviceForms) => {
  return serviceForms.map((serviceForm) => {
    console.log("we are here dev", serviceForm?.latestProcessingStatus)
    return {
      ...serviceForm,
      modServiceName: serviceForm?.form?.service?.serviceName,
      modServiceDescription: serviceForm?.form?.service?.serviceDescription,
      modCategoryName: serviceForm?.form?.service?.serviceCategory?.categoryName,
      latestProcessingStatus: serviceForm?.latestProcessingStatus ? {
        ...serviceForm?.latestProcessingStatus,
        modOtherFields: serviceForm?.latestProcessingStatus?.otherFields ? JSON.parse(serviceForm?.latestProcessingStatus?.otherFields?.replaceAll('\'', '"')) : [],
      } : null,
      processingHistory: serviceForm?.processingHistory?.map(h => {
        return {
          ...h,
          modOtherFields: serviceForm?.latestProcessingStatus?.otherFields ? JSON.parse(serviceForm?.latestProcessingStatus?.otherFields?.replaceAll('\'', '"')) : []
        }
      }),
      modSubmittedAt: serviceForm?.form?.createdAt ? new DatePipe('en-GB').transform(serviceForm?.form?.createdAt, 'MMM dd, y HH:mm') : '-',
      modTrackingInfoStatus: serviceForm?.trackingInfo?.status,
      modTrackNumber: serviceForm?.relayInfo?.trackNumber,
    };
  });
});

export const selectModifiedFromResponseByUid = (uniqueId) => createSelector(selectModifiedFromResponses, (serviceForms) => {
  return serviceForms.find((serviceForm) => serviceForm.uniqueId === uniqueId);
});
